import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, EventEmitter, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UtilService } from '../util/util.service';
import { map } from 'rxjs/operators';
import { BEEHOME_API_URL, SERVER_URL } from 'src/app/config';
import { PagedData } from 'src/app/models/page-data';
import { IOrganizationBase } from '../../interfaces/organization-base/organization-base.interface';
import { IWorkflowSuperObject } from '../../interfaces/workflow/workflow-super-object.interface';
import { IWorkflowStepSuperObject } from '../../interfaces/workflow/workflow-step-super-object.interface';
import { IWorkflow } from '../../interfaces/workflow/workflow.interface';
import { IWorkflowType } from '../../interfaces/workflow/workflow-type.interface';
import { Page } from 'src/app/models/page';
import { IWorkflowStep } from 'src/app/interfaces/workflow/workflow-step.interface';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {
  private readonly http = inject(HttpClient);
  private util = inject(UtilService);
  private router = inject(Router);

  selectedPoll: any;
  workflowId: any;
  recaptchaToken = null;
  externalWorkflowType = null;
  hasStepsToUser = true;
  //GET
  get(id) {
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflows/' + id).pipe(map((data: IWorkflow) => data
    ));
  }

  getConsult(id) {
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflows/consult/' + id).pipe(map((data: IWorkflow) => data
    ));
  }

  getExternal(id) {
    return this.http.get(SERVER_URL + '/workflows/external/' + id).pipe(map((data: IWorkflow) => data
    ));
  }

  trackAnonymousWorkflow(protocol: string, password: string) {
    return this.http.post(SERVER_URL + '/workflows/external/' + encodeURIComponent(protocol) + '/track', { password }).pipe(map((data: IWorkflow) => data));
  }

  deleteWorkflow(workflowId){
    return this.http.delete(SERVER_URL + '/workflows/' + workflowId).pipe(map((data: IWorkflow) => data
    ));
  }

  list(userId: number, page: Page, status, searchText,protocolMyRequest) {
    const { pageNumber, size } = page;
    const httpParams = { first: String(pageNumber * size), pageSize: String(size), filter: status, searchText: searchText,protocol:protocolMyRequest };
    return this.http.get(SERVER_URL + '/workflows/users/' + userId, { params: httpParams }).pipe(map((data: IWorkflowSuperObject) => this.getWorkflowPagedData(data, page,  userId)));
  }

  listMyRequestsByQuery(userId: number, page: Page, status: string, q: string) {
    const { pageNumber, size } = page;
    const httpParams = {
      first: String(pageNumber * size),
      pageSize: String(size),
      status: status ?? 'ALL',
      q: q ?? ''
    };
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    // Param `q` unificado substitui searchText + protocol do monolito —
    // busca (OR) em title, description, protocol, answer text, question title.
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflows/users/' + userId, { params: httpParams }).pipe(map((data: IWorkflowSuperObject) => this.getWorkflowPagedData(data, page, userId)));
  }

  getType(id) {
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflowtypes/' + id).pipe(map((data: IWorkflowType) => data));
  }

  hasOpenWorkflowByType(id) {
    return this.http.get(SERVER_URL + '/workflowTypes/' + id + '/open-workflow/exist').pipe(map((data: boolean) => data));
  }

  listTypesCategoryToUser(userId) {
    const httpParams: HttpParams = new HttpParams().set('userId', userId ?? 0);
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflowtypes/list/bycategory', { params: httpParams }).pipe(map((data: IWorkflowType[]) => data));
  }

  listTypesCategoryToUserManager(userId) {
    const httpParams: HttpParams = new HttpParams().set('userId', userId ?? 0);
    return this.http.get(SERVER_URL + '/workflowTypes/list/byCategory/userManager', { params: httpParams }).pipe(map((data: IWorkflowType[]) => data));
  }

  listTypesCategories() {
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflowtypes/list/categories').pipe(map((data: any) =>  data));
  }

  listStepsToManager(userId: number, page: Page, status: string, statusDeadline, protocol,searchAll, requesterId, typeId, order = 'NEWER', unityId=0 ) {
    const { pageNumber, size } = page;
    const httpParams = { 
      first: String(pageNumber * size), 
      pageSize: String(size), 
      status:  String(status), 
      statusDeadline: statusDeadline, 
      protocol: protocol, 
      searchAll: searchAll, 
      requesterId, 
      typeId, 
      order: order,
      unityId: unityId
    };
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    // Substitui /workflows/steps/users/{id}/manager do monolito (Q3+Q5 do slow
    // log 2026-05-19, 4.6-5.3s × 7.6 calls/h). Lambda PR: beehome-api-workflow#14.
    return this.http.get(`${SERVER_URL}${BEEHOME_API_URL}/workflow/workflows/steps/users/${userId}/manager`, {params: httpParams}).pipe(map((data: IWorkflowStepSuperObject) => this.getStepsManagerPagedData(data, page, userId)));
  }

  listStepsToManagerConsultFlow(userId: number, page: Page, status: string, statusDeadline, protocol,searchAll, requesterId, typeId, workflowAdmSelected,category, order, unityId=0) {
    const { pageNumber, size } = page;
    const timeZoneOffset = new Date().getTimezoneOffset();
    const gmt = `GMT${timeZoneOffset > 0 ? '-' : '+'}${Math.abs(timeZoneOffset / 60)}`;
    const httpParams = { 
      first: String(pageNumber * size), 
      pageSize: String(size), 
      status:  String(status), 
      statusDeadline: statusDeadline, 
      protocol: protocol, 
      searchAll: searchAll, 
      requesterId, 
      typeId,
      workflowAdmSelected: workflowAdmSelected,
      category: category, 
      order: order,
      gmt: gmt,
      unityId: unityId
    };
    return this.http.get(`${SERVER_URL}${BEEHOME_API_URL}/workflow/workflows/steps/users/consultflow/${userId}/manager`, {params: httpParams}).pipe(map((data: IWorkflowStepSuperObject) => this.getStepsManagerPagedData(data, page, userId)));
  }

  exportStepsToManager(userId: number, page: Page, status: string, statusDeadline, protocol,searchAll, requesterId, typeId, unityId) {
    const httpParams = { status:  String(status), statusDeadline: statusDeadline, protocol: protocol, searchAll: searchAll, requesterId, typeId, userZone: this.util?.userZone, unityId};
    return this.http.post(`${SERVER_URL}/workflows/reports/steps/users/${userId}/manager`, null, { responseType: 'arraybuffer', params: httpParams }).pipe(map((data: any) => data));
  }

  exportConsultStepsToManager(userId: number, page: Page, status: string, statusDeadline, protocol,searchAll, requesterId, typeId,admId,category) {
    const timeZoneOffset = new Date().getTimezoneOffset();
    const gmt = `GMT${timeZoneOffset > 0 ? '-' : '+'}${Math.abs(timeZoneOffset / 60)}`;
    
    const httpParams = {
      status:  String(status), 
      statusDeadline: statusDeadline, 
      protocol: protocol, 
      searchAll: searchAll, 
      requesterId, 
      typeId, 
      userZone: this.util?.userZone,
      admId:admId,
      category: category,
      gmt:gmt
    };
    
    return this.http.post(`${SERVER_URL}/workflows/reports/consult/steps/users/${userId}/manager`, null, { responseType: 'arraybuffer', params: httpParams }).pipe(map((data: any) => data));
  }

  getChartManagerAll(workflowType) {
    const httpParams: HttpParams = new HttpParams().set('workflowTypeId', workflowType?.id ? workflowType?.id: '').set('type', workflowType?.name ? workflowType?.name: 'Todos');
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflows/analytics/chart/manager/all', {params: httpParams}).pipe(map((data: any) => {
      return data;
    }));
  }

  getChartManagerLonger(workflowType) {
    const httpParams: HttpParams = new HttpParams().set('workflowTypeId', workflowType?.id ? workflowType?.id: '').set('type', workflowType?.name ? workflowType?.name: 'Todos');
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflows/analytics/chart/manager/longer', {params: httpParams}).pipe(map((data: any) => {
      return data;
    }));
  }
  
  listUserFavorites() {
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflowTypes/favorite').pipe(map((data: IWorkflowType[]) => data));
  }

  listFilteredTypes() {
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflowtypes/list/filtered').pipe(map((data: IWorkflowType[]) => data));
  }

  exportWorkflowToPdf(id, stepId) {
    const paramsString = '?workflowId=' + id + '&stepId=' + stepId;
    const httpParams: HttpParams = new HttpParams()
    .set('userZone', this.util.userZone);
    return this.http.get(SERVER_URL + '/workflows/reports/doc' + paramsString, { responseType: 'arraybuffer' , params: httpParams }).pipe(map((data: any) => {
      return data;
    }));
  }

  //POST
  createWorkflow(workflowObject, answersObject) {
    if (answersObject) {
      workflowObject.answersObject = answersObject;
    }

    const httpParams: HttpParams = new HttpParams().append('userZone', this.util?.userZone);
    return this.http.post(SERVER_URL + '/workflows/', workflowObject, { params: httpParams }).pipe(map((data: any) => {
      this.workflowId=data;
    return data;
    }));
  }

  createWorkflowType(workflowTypeObject) {
        //checagem de se uma etapa com responsável ownersCompanyDepartmentIds, se tiver, transforma o obj para um que o server aceita 
        if(workflowTypeObject?.workflowTypeStepObjectList){
          workflowTypeObject.workflowTypeStepObjectList.forEach(obj => {
            if (obj?.hasOwnProperty('ownersCompanyDepartmentIds')) {
              const ownersCompanyDepartmentIds = [];
              //verificação se existe o companyDepartment
              if(!this.verifyCompanyDepartment(obj?.ownersCompanyDepartmentIds)){
              for (const key in obj.ownersCompanyDepartmentIds) {
                
                if (obj.ownersCompanyDepartmentIds.hasOwnProperty(key)) {
                  const companyDepartment = parseInt(key);
                  const users = obj.ownersCompanyDepartmentIds[key];
                  ownersCompanyDepartmentIds.push({ companyDepartment, users });
                }
              }
              obj.ownersCompanyDepartmentIds = ownersCompanyDepartmentIds;
            }
            }
          });
        }
    return this.http.post(SERVER_URL + '/workflowTypes/', workflowTypeObject).pipe(map((data: any) => data));
  }

  updateWorkflowTypeResponsible(listWorkFlowTypeStep,userManager,newUserManager){
    const httpParams: HttpParams = new HttpParams().set('userManager', userManager).set('newUserManager', newUserManager);
    return this.http.put(SERVER_URL + '/workflowTypes/responsible', listWorkFlowTypeStep, { params: httpParams }).pipe(map((data: any) => data));
  }

  deleteWorkflowTypeResponsible(listWorkFlowTypeStep,userManager){
    const httpParams: HttpParams = new HttpParams().set('userManager', userManager);
    return this.http.put(SERVER_URL + '/workflowTypes/responsible/delete', listWorkFlowTypeStep, { params: httpParams }).pipe(map((data: any) => data));  
  }

  //PUT
  updateWorkflowType(workflowTypeObject) {
    //checagem de se uma etapa com responsável ownersCompanyDepartmentIds, se tiver, transforma o obj para um que o server aceita 
    if(workflowTypeObject?.workflowTypeStepObjectList){
      workflowTypeObject.workflowTypeStepObjectList.forEach(obj => {
        if (obj?.hasOwnProperty('ownersCompanyDepartmentIds')) {
          const ownersCompanyDepartmentIds = [];
          //verificação se existe o companyDepartment
          if(!this.verifyCompanyDepartment(obj?.ownersCompanyDepartmentIds)){
          for (const key in obj.ownersCompanyDepartmentIds) {
            
            if (obj.ownersCompanyDepartmentIds.hasOwnProperty(key)) {
              const companyDepartment = parseInt(key);
              const users = obj.ownersCompanyDepartmentIds[key];
              ownersCompanyDepartmentIds.push({ companyDepartment, users });
            }
          }
          obj.ownersCompanyDepartmentIds = ownersCompanyDepartmentIds;
        }
        }
      });
    }
    return this.http.put(SERVER_URL + '/workflowTypes/', workflowTypeObject).pipe(map((data: any) => data));
  }

  assignStep(workflowId, stepId, userId) {
    const httpParams: HttpParams = new HttpParams().append('userZone', this.util?.userZone);
    return this.http.put(SERVER_URL + `/workflows/${workflowId}/steps/${stepId}/assign/${userId}`, null, { params: httpParams }).pipe(map((data: any) => data));
  }

  approveStep(workflowId, stepId, obj) {
    const httpParams: HttpParams = new HttpParams().append('userZone', this.util?.userZone);
    return this.http.put(SERVER_URL + `/workflows/${workflowId}/steps/${stepId}/approve`, obj, { params: httpParams }).pipe(map((data: any) => data));
  }

  rejectStep(workflowId, stepId, obj, backToPrevious) {
    const httpParams: HttpParams = new HttpParams().append('userZone', this.util?.userZone).append('backToPrevious', backToPrevious);
    return this.http.put(SERVER_URL + `/workflows/${workflowId}/steps/${stepId}/reject`, obj, { params: httpParams }).pipe(map((data: any) => data));
  }

  backStep(workflowId, stepId, lastStepId) {
    const httpParams: HttpParams = new HttpParams().append('userZone', this.util?.userZone).append('lastStepId', lastStepId);
    return this.http.put(SERVER_URL + `/workflows/${workflowId}/steps/${stepId}/back`, null, { params: httpParams }).pipe(map((data: any) => data));
  }

  cancelWorkflow(workflowId, workflowStepId,comment) {
    const httpParams: HttpParams = new HttpParams().append('userZone', this.util?.userZone).append('workflowStepId', workflowStepId).append('comment', comment);
    return this.http.put(`${SERVER_URL}/workflows/${workflowId}/cancel`, null, { params: httpParams }).pipe(map((data: any) => data));
  }

  newStepAssignedTo(workflowStepId, newUserStepAssignedToId) {
    const httpParams: HttpParams = new HttpParams().append('userZone', this.util?.userZone);
    return this.http.put(`${SERVER_URL}/workflows/alter/workflowstep/${workflowStepId}/assignedto/${newUserStepAssignedToId}`, { params: httpParams }).pipe(map((data: any) => data));
  }

  //DELETE
  deleteType(id) {
    return this.http.delete(SERVER_URL + '/workflowTypes/' + id).pipe(map((data: any) => data));
  }

  // ANALYTICS AND REPORTS

  getPendingRequestsQuantity(workflowType) {
    const httpParams: HttpParams = new HttpParams().set('workflowTypeId', workflowType?.id ? workflowType?.id: '').set('type', workflowType?.name ? workflowType?.name: 'Todos');

    return this.http.get(SERVER_URL + BEEHOME_API_URL +'/workflow/workflows/analytics/requestsQuantity/pending', { params: httpParams }).pipe(map((data: IOrganizationBase) => data));
  }

  getRequestsQuantityByWorkflowType(startDate: Date, endDate: Date) {
    const httpParams: HttpParams = new HttpParams().set('startDate', startDate?.getTime()?.toString() ?? '0').set('endDate', endDate?.getTime()?.toString() ?? '0');

    return this.http.get(`${SERVER_URL}/workflows/analytics/workflowTypes/requestsQuantity`, { params: httpParams }).pipe(map((data: IOrganizationBase[]) => data));
  }

  getRequestsQuantityByCompanyDepartment(workflowType: any, startDate: Date, endDate: Date) {
    const httpParams: HttpParams = new HttpParams().set('workflowTypeId', workflowType?.id? workflowType?.id.toString() : '').set('startDate', startDate?.getTime()?.toString() ?? '').set('endDate', endDate?.getTime()?.toString() ?? '').set('type', workflowType?.name? workflowType?.name : 'Todos');

    return this.http.get(`${SERVER_URL}/workflows/analytics/companyDepartments/requestsQuantity`, { params: httpParams }).pipe(map((data: IOrganizationBase[]) => data));
  }

  hasWorfklowStepsToUser(userId) {
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.get(`${SERVER_URL}${BEEHOME_API_URL}/workflow/workflows/steps/all/count/users/${userId}`).pipe(map((data: boolean) => this.hasStepsToUser = data));
  }

  getWorkflowsReport(workflowsReportPage: Page, filterFormRawValue: any) {
    const { pageNumber, size } = workflowsReportPage;

    const { workflowCreator, workflowActionBy, workflowType, companyDepartment, department, jobTitle, group, workflowStatus, isManagerCreate, startDate, endDate, category } = filterFormRawValue;

    const isPossibleFilterByEntities = !workflowType?.publicEntity ? true : false;

    const httpParams: HttpParams = new HttpParams()
      .append('first', (pageNumber * size)?.toString() ?? '')
      .append('maxResults', size?.toString() ?? '')
      .append('workflowCreatorId', workflowCreator?.id ?? '')
      .append('workflowActionById', workflowActionBy?.id ?? '')
      .append('workflowTypeId', workflowType?.id ?? '')
      .append('companyDepartmentId', isPossibleFilterByEntities && companyDepartment?.id ? companyDepartment?.id : '')
      .append('departmentId', isPossibleFilterByEntities && department?.id ? department?.id : '')
      .append('jobTitleId', isPossibleFilterByEntities && jobTitle?.id ? jobTitle?.id : '')
      .append('groupId', isPossibleFilterByEntities && group?.id ? group.id : '')
      .append('workflowStatus', workflowStatus ?? '')
      .append('isManagerCreate', isManagerCreate ? true : false)
      .append('startDate', startDate?.getTime()?.toString() ?? '')
      .append('endDate', endDate?.getTime()?.toString() ?? '')
      .append('categoryId', category?.id ?? '');

    return this.http.get(`${SERVER_URL}/workflows/reports/list`, { params: httpParams }).pipe(map((data: IWorkflowSuperObject) => this.getWorkflowsReportPagedData(data, workflowsReportPage)));
  }

  exportWorkflowsReport(filterFormRawValue: any) {
    const { workflowCreator, workflowActionBy, workflowType, companyDepartment, department, jobTitle, group, workflowStatus,isManagerCreate, startDate, endDate, category } = filterFormRawValue;

    const isPossibleFilterByEntities = !workflowType?.publicEntity ? true : false;

    const httpParams: HttpParams = new HttpParams()
      .append('userZone', this.util?.userZone)
      .append('workflowCreatorId', workflowCreator?.id ?? '')
      .append('workflowActionById', workflowActionBy?.id ?? '')
      .append('workflowTypeId', workflowType?.id ?? '')
      .append('companyDepartmentId', isPossibleFilterByEntities && companyDepartment?.id ? companyDepartment?.id : '')
      .append('departmentId', isPossibleFilterByEntities && department?.id ? department?.id : '')
      .append('jobTitleId', isPossibleFilterByEntities && jobTitle?.id ? jobTitle?.id : '')
      .append('groupId', isPossibleFilterByEntities && group?.id ? group.id : '')
      .append('workflowStatus', workflowStatus ?? '')
      .append('isManagerCreate', isManagerCreate ? true : false)
      .append('startDate', startDate?.getTime()?.toString() ?? '')
      .append('endDate', endDate?.getTime()?.toString() ?? '')
      .append('categoryId', category?.id ?? '');

    return this.http.post(`${SERVER_URL}/workflows/reports/export`, null, { responseType: 'arraybuffer', params: httpParams }).pipe(map((data: any) => data));
  }

  getLateWorkflowsReport(workflowStepsReportPage: Page, filterFormRawValue: any) {
    const { pageNumber, size } = workflowStepsReportPage;

    const { workflowType, startDate, endDate, companyDepartment, category } = filterFormRawValue;

    const isPossibleFilterByEntities = !workflowType?.publicEntity ? true : false;

    const httpParams: HttpParams = new HttpParams()
      .append('first', (pageNumber * size)?.toString() ?? '')
      .append('maxResults', size?.toString() ?? '')
      .append('workflowTypeId', workflowType?.id ?? '')
      .append('startDate', startDate?.getTime()?.toString() ?? '')
      .append('endDate', endDate?.getTime()?.toString() ?? '')
      .append('companyDepartmentId', isPossibleFilterByEntities && companyDepartment?.id ? companyDepartment?.id : '')
      .append('categoryId', category?.id ?? '');

    return this.http.get(`${SERVER_URL}/workflows/reports/late/steps/list`, { params: httpParams }).pipe(map((data: IWorkflowStepSuperObject) => this.getWorkflowStepsReportPagedData(data, workflowStepsReportPage)));
  }

  exportLateWorkflowsReport(filterFormRawValue: any) {
    const { workflowType, startDate, endDate,companyDepartment, category } = filterFormRawValue;

    const isPossibleFilterByEntities = !workflowType?.publicEntity ? true : false;

    const httpParams: HttpParams = new HttpParams()
      .append('userZone', this.util?.userZone)
      .append('workflowTypeId', workflowType?.id ?? '')
      .append('startDate', startDate?.getTime()?.toString() ?? '')
      .append('endDate', endDate?.getTime()?.toString() ?? '')
      .append('companyDepartmentId', isPossibleFilterByEntities && companyDepartment?.id ? companyDepartment?.id : '')
      .append('categoryId', category?.id ?? '');

    return this.http.post(`${SERVER_URL}/workflows/reports/late/steps/export`, null, { responseType: 'arraybuffer', params: httpParams }).pipe(map((data: any) => data));
  }

  getWorkflowStepsReport(workflowStepsReportPage: Page, filterFormRawValue: any) {
    const { pageNumber, size } = workflowStepsReportPage;

    const { workflowActionBy, workflowCreator, workflowType, workflowTypeStep, workflowStepStatus, startDate, endDate, companyDepartment } = filterFormRawValue;
    
    const isPossibleFilterByEntities = !workflowType?.publicEntity ? true : false;

    const httpParams: HttpParams = new HttpParams()
      .append('first',  (pageNumber * size)?.toString() ?? '')
      .append('maxResults', size?.toString() ?? '')
      .append('workflowActionById', workflowActionBy?.id ?? '')
      .append('workflowCreatorId', workflowCreator?.id ?? '')
      .append('workflowTypeId', workflowType?.id ?? '')
      .append('workflowTypeStepId', workflowTypeStep?.id ?? '')
      .append('workflowStepStatus', workflowStepStatus ?? '')
      .append('companyDepartmentId', isPossibleFilterByEntities && companyDepartment?.id ? companyDepartment?.id : '')
      .append('startDate', startDate?.getTime()?.toString() ?? '')
      .append('endDate', endDate?.getTime()?.toString() ?? '');

    return this.http.get(`${SERVER_URL}/workflows/reports/steps/list`, { params: httpParams }).pipe(map((data: IWorkflowStepSuperObject) => this.getWorkflowStepsReportPagedData(data, workflowStepsReportPage)));
  }

  exportWorkflowStepsReport(filterFormRawValue: any) {
    const { workflowActionBy, workflowCreator, workflowType, workflowTypeStep, workflowStepStatus, startDate, endDate, companyDepartment } = filterFormRawValue;

    const isPossibleFilterByEntities = !workflowType?.publicEntity ? true : false;
    
    const httpParams: HttpParams = new HttpParams()
      .append('userZone', this.util?.userZone)
      .append('workflowActionById', workflowActionBy?.id ?? '')
      .append('workflowCreatorId', workflowCreator?.id ?? '')
      .append('workflowTypeId', workflowType?.id ?? '')
      .append('workflowTypeStepId', workflowTypeStep?.id ?? '')
      .append('workflowStepStatus', workflowStepStatus ?? '')
      .append('companyDepartmentId', isPossibleFilterByEntities && companyDepartment?.id ? companyDepartment?.id : '')
      .append('startDate', startDate?.getTime()?.toString() ?? '')
      .append('endDate', endDate?.getTime()?.toString() ?? '');

    return this.http.post(`${SERVER_URL}/workflows/reports/steps/export`, null, { responseType: 'arraybuffer', params: httpParams }).pipe(map((data: any) => data));
  }

  /**
    * POLL
  */

  editAnswerWorkflow(id, answerObject) {
    return this.http.put(SERVER_URL + '/workflows/' + id + '/answer', answerObject).pipe(map((data: any) =>
        data
    ));
  }

  getPoll(pollId,restrictQuestion?) {
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    const queryString = restrictQuestion !== undefined ? `?restrictQuestion=${restrictQuestion}` : '';
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflowtypes/poll/' + pollId + queryString).pipe(map((data: any) => {
      this.selectedPoll = data;
      return data;
    }));
  }

  getAnswers(userId,workflowId) {
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.get(SERVER_URL + BEEHOME_API_URL + `/workflow/workflows/answers/${userId}/${workflowId}`).pipe(map((data: any) => data));
  }

  getDeletedQuestionAnswers(userId,workflowId) {
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.get(SERVER_URL + BEEHOME_API_URL + `/workflow/workflows/deletedquestionsanswers/${userId}/${workflowId}`).pipe(map((data: any) => data));
  }

  getExternalAnswers(userId,workflowId) {
    return this.http.get(SERVER_URL + `/external/workflows/answers/${userId}/${workflowId}`).pipe(map((data: any) => data));
  }

  createPoll(id, poll) {
    return this.http.post(SERVER_URL + '/workflowTypes/' + id + '/poll/insert', poll).pipe(map((data: any) => data));
  }

  private getWorkflowPagedData(data: IWorkflowSuperObject, page: Page, loggedUserId: number) {
    const pagedData = new PagedData();
    page.totalElements = data.recordsTotal;
    page.totalPages = page.totalElements / page.size;

    if (data?.data?.list) {
      for (const obj of data.data.list) {
        const workflow = {
          id: obj.id,
          type: obj.workflowTypeTO ? obj.workflowTypeTO.title : null,
          lastUpdateOn: obj.lastUpdatedOn,
          createdOn: obj.createdOn,
          protocol: obj.protocol,
          accompaniedBy: obj.accompaniedBy ? obj.accompaniedBy : null,
          currentStep: '',
          status: '',
          isTypeDeleted: !obj.workflowTypeTO || obj?.workflowTypeTO?.status == 'EXCLUIDO' ? true : false
        };
        obj.workflowStepTOList.forEach(element => {
          if (element?.current) {
            if (element?.approved) {
              workflow.status = 'Aprovado';
            } else if (!element?.approved && element?.updatedOn) {
              workflow.status = 'Rejeitado';
            } else if (!element?.workflowTypeStepTO?.thereAreUsersToApproveOrReject || !element.updatedOn) {
              if (element?.assignedTo && element?.assignedTo?.id === loggedUserId) {
                workflow.status = 'Pendente de sua ação';
              } else {
                workflow.status = 'Pendente';
              }
            }
            workflow.currentStep = element?.workflowTypeStepTO?.description;
          }
        });

        workflow.currentStep = workflow.currentStep === '' ? obj.workflowTypeTO?.description : workflow.currentStep;

        if (obj?.canceled) {
          workflow.status = 'Cancelado pelo solicitante';
        } else if (obj?.canceledByManager) {
          workflow.status = 'Cancelado pelo gestor';
        } else if (workflow?.isTypeDeleted) {
          workflow.status = 'Fluxo excluído';
        } else if (!workflow?.status) {
          const lastWorkflowStep = obj.workflowStepTOList[obj.workflowStepTOList.length - 1];
          if (lastWorkflowStep?.approved) {
            workflow.status = 'Aprovado';
          } else {
            workflow.status = 'Rejeitado';
          }
        }
        pagedData.data.push(workflow);
      }
    }

    pagedData.page = page;
    return pagedData;
  }

  private getWorkflowsReportPagedData(data: IWorkflowSuperObject, page: Page): PagedData<any> {
    const pagedData = new PagedData();
    page.totalElements = data?.recordsTotal;
    page.totalPages = page?.totalElements / page?.size;

    for (const workflow of data?.data?.list) {
      workflow.remainingStepsQuantity = this.countWorkflowRemainingSteps(workflow.workflowStepTOList);
      workflow.status = workflow.canceled ? 'Cancelado pelo solicitante' : (workflow.canceledByManager ? 'Cancelado pelo gestor' : (workflow.remainingStepsQuantity ? 'Em Progresso' : 'Concluído'));
      workflow.finishedOn = workflow.remainingStepsQuantity ? null : workflow.workflowStepTOList?.[workflow?.workflowStepTOList?.length - 1]?.updatedOn ?? null;
    }

    pagedData.data = [...pagedData.data, ...data?.data?.list ?? []];
    pagedData.page = page;

    return pagedData;
  }

  private getStepsManagerPagedData(data: IWorkflowStepSuperObject, page, userId) {
    const pagedData = new PagedData();
    page.totalElements = data.recordsTotal;
    page.totalPages = page.totalElements / page.size;
    if (data?.data?.list) {
      for (const obj of data.data.list) {
        let statusString = '';
        if (obj.approved && obj?.typeDeleted) {
          statusString = 'Fluxo Excluido Aprovado';
        } else if (!obj.approved && obj.updatedOn && obj?.typeDeleted){
          statusString = 'Fluxo Excluido Rejeitado';
        }else if(obj.approved){
          statusString = 'Aprovado';
        }else if (!obj.approved && obj.updatedOn && (obj.tryNumber == obj.tryNumberCurrent || obj.stepOrder == 0)) {
          statusString = 'Rejeitado';
        } else if (obj?.canceled) {
          statusString = 'Cancelado pelo solicitante';
        } else if (obj?.canceledByManager) {
          statusString = 'Cancelado pelo gestor';
        } else if (obj?.typeDeleted) {
          statusString = 'Fluxo excluído';
        } else if (!obj.workflowTypeStepTO?.thereAreUsersToApproveOrReject || !obj.updatedOn) {
          statusString = 'Pendente';
        }
        const step = {
          id: obj.id,
          workflowId: obj.workflowId,
          type: obj.workflowTypeStepTO?.workflowTypeTitle,
          status: statusString,
          current: obj?.current,
          ownersUserIds: obj.workflowTypeStepTO?.ownersUserIds,
          ownersJobTitles: obj.workflowTypeStepTO?.ownersJobTitleIds,
          lastUpdateOn: obj.updatedOn ? obj.updatedOn : obj.createdOn,
          createdBy: obj.createdBy,
          assignedTo: obj.assignedTo ? obj.assignedTo : null,
          createdOn: obj.createdOn,
          sla: obj.workflowTypeStepTO?.sla,
          workflowTypeStepTO: obj.workflowTypeStepTO,
          deadline: obj.deadline ?? null,
          protocol: obj.workflowProtocol,
          category: obj.workflowCategory,
          // eslint-disable-next-line eqeqeq
          isToMe: obj.assignedTo && obj.assignedTo.id == userId ? true : false,
          attachReply: obj.workflowTypeStepTO?.attachReply
        };
        pagedData.data.push(step);
      }
    }
    pagedData.page = page;
    return pagedData;
  }

  private getWorkflowStepsReportPagedData(data: IWorkflowStepSuperObject, page: Page): PagedData<any> {
    const pagedData = new PagedData();
    page.totalElements = data?.recordsTotal;
    page.totalPages = page?.totalElements / page?.size;

    pagedData.data = [...pagedData.data, ...data?.data?.list ?? []];
    pagedData.page = page;

    return pagedData;
  }

  private countWorkflowRemainingSteps(workflowStepList: IWorkflowStep[]): number {
    return workflowStepList.reduce((quantity, workflowStep) => quantity + (workflowStep?.updatedOn ? 0 : 1), 0);
	}

  getConfiguration() {
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflows/configuration/list').pipe(map((data: any) => data));
  }

  saveConfiguration(obj) {
    return this.http.post(SERVER_URL + '/workflows/configuration', obj).pipe(map((data: any) => data));
  }

  createTypeCategory(obj) {
    return this.http.post(SERVER_URL + '/workflowTypes/category/', obj).pipe(map((data: IWorkflowType[]) => data));
  }

  updateTypeCategory(obj) {
    return this.http.put(SERVER_URL + '/workflowTypes/category/', obj).pipe(map((data: IWorkflowType[]) => data));
  }

  deleteTypeCategory(id) {
    return this.http.delete(SERVER_URL + '/workflowTypes/category?id=' + id).pipe(map((data: IWorkflowType[]) => data));
  }

  isCategoryManager() {
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.get(SERVER_URL + BEEHOME_API_URL + '/workflow/workflowtypes/category/manager').pipe(map((data: any) => data));
  }

  saveWorkflowTypeOrder(workflowTypeId,orderCategory){
    return this.http.put(SERVER_URL + '/workflowTypes/'+workflowTypeId+'/orderCategory?orderCategory='+orderCategory,null).pipe(map((data: any) => data));
  }

  exportStepsToStepManager(userId: number, page: Page, status: string, statusDeadline, protocol,searchAll, requesterId, typeId, responsibleId) {
    const httpParams = { status:  String(status), statusDeadline: statusDeadline, protocol: protocol, searchAll: searchAll, requesterId, typeId, userZone: this.util?.userZone,responsibleId};
    return this.http.post(`${SERVER_URL}/workflows/reports/steps/users/${userId}/stepManager`, null, { responseType: 'arraybuffer', params: httpParams }).pipe(map((data: any) => data));
  }


  getChartToStepManager(status: string, statusDeadline, protocol,searchAll, requesterId, typeId, responsibleId) {
    const httpParams = { status:  String(status), statusDeadline: statusDeadline, protocol: protocol, searchAll: searchAll, requesterId, typeId, responsibleId};
    return this.http.get(SERVER_URL + '/workflows/analytics/chart/stepManager', {params: httpParams}).pipe(map((data: any) => {
      return data;
    }));
  }


 
  listStepsToManagerStep(userId: number, page: Page, status: string, statusDeadline, protocol,searchAll, requesterId, typeId,responsibleId) {
    const { pageNumber, size } = page;
    const httpParams = { first: String(pageNumber * size), pageSize: String(size), status:  String(status), statusDeadline: statusDeadline, protocol: protocol, searchAll: searchAll, requesterId, typeId, responsibleId};
    return this.http.get(`${SERVER_URL}/workflows/steps/users/${userId}/stepManager`, {params: httpParams}).pipe(map((data: IWorkflowStepSuperObject) => this.getStepsManagerPagedData(data, page, userId)));
  }

  listStepsToManagerStepAll(userId: number, page: Page, status: string, statusDeadline, protocol,searchAll, requesterId, typeId,responsibleId) {
    const { pageNumber, size } = page;
    const httpParams = { first: 0, pageSize: 0, status:  String(status), statusDeadline: statusDeadline, protocol: protocol, searchAll: searchAll, requesterId, typeId, responsibleId};
    return this.http.get(`${SERVER_URL}/workflows/steps/users/${userId}/stepManager`, {params: httpParams}).pipe(map((data: IWorkflowStepSuperObject) => this.getStepsManagerPagedData(data, page, userId)));
  }


  getUsersPossibleToResponsibleStep(workflowStepTo){
    let workflowTypeStepObject ={
      id: workflowStepTo.id,
      ownersGroupIds: workflowStepTo?.ownersGroupIds,
      ownersJobTitleIds: workflowStepTo?.ownersJobTitleIds,
      ownersJobTitleGroupIds: workflowStepTo?.ownersJobTitleGroupIds,
      ownersTeamIds: workflowStepTo?.ownersTeamIds,
      companyDepartmentIds: workflowStepTo?.ownersCompanyDepartmentIds ? Object.keys(workflowStepTo?.ownersCompanyDepartmentIds).map(chave => parseInt(chave)) : null
    }
    // Migrado para Lambda beehome-api-workflow (rota ALB /api/workflow/*).
    return this.http.put(SERVER_URL + BEEHOME_API_URL + '/workflow/workflowtypes/steps/liststepmanager', workflowTypeStepObject).pipe(map((data) => data));
  }

  getUsersPossibleToResponsibleStepAll(workflowStepToList){
    let workflowTypeStepObject=[];
    if(workflowStepToList){
      for (const iterator of workflowStepToList) {
        workflowTypeStepObject.push({
          id: iterator.id,
          ownersGroupIds: iterator?.ownersGroupIds,
          ownersJobTitleIds: iterator?.ownersJobTitleIds,
          ownersJobTitleGroupIds: iterator?.ownersJobTitleGroupIds,
          ownersTeamIds: iterator?.ownersTeamIds,
          companyDepartmentIds: iterator?.ownersCompanyDepartmentIds ? Object.keys(iterator?.ownersCompanyDepartmentIds).map(chave => parseInt(chave)) : null,
          workflowTypeId:iterator?.workflowTypeId,
        })
      }
    }
    return this.http.put(SERVER_URL + '/workflowTypes/steps/listStepManagerAll', workflowTypeStepObject).pipe(map((data) => data));
  }

  changeStepResponsible(stepId, userId){
    return this.http.put(SERVER_URL +"/workflows/changeResponsibleStep/"+stepId+"/"+userId,null).pipe(map((data) => data));
  }

  changeStepResponsibleAll(userId, stepIdList){
    return this.http.put(SERVER_URL +"/workflows/changeResponsibleStepAll/"+userId,stepIdList).pipe(map((data) => data));
  }


  // Fluxos externos

  createExternalWorkflow(workflowObject, answerObject) {
    if (answerObject) {
      answerObject.workflowRecaptcha = this.recaptchaToken;
      workflowObject.answersObject = answerObject;
    }

    return this.http.post(SERVER_URL + '/workflows/external/', workflowObject).pipe(map((data: any) => {
      this.workflowId=data;
    return data;
    }));
  }

  listExternalTypeCategories() {
    return this.http.get(SERVER_URL + '/workflowTypes/list/external/byCategory').pipe(map((data: IWorkflowType[]) => data));
  }

  getWorkflowTypeExternal(workflowTypeId: number) {
    return this.http.get(SERVER_URL + '/workflowTypes/external/' + workflowTypeId).pipe(map((data: IWorkflowType) => data));
  }

   verifyCompanyDepartment(objeto) {
    if (Array.isArray(objeto)) {
      for (let i = 0; i < objeto.length; i++) {
        if (objeto[i].hasOwnProperty("companyDepartment")) {
          return true;
        }
      }
    } else if (typeof objeto === "object") {
      for (let key in objeto) {
        if (objeto.hasOwnProperty(key)) {
          if (this.verifyCompanyDepartment(objeto[key])) {
            return true;
          }
        }
      }
    }
    return false;
  }
}
